import React, { useEffect, useReducer, useCallback } from "react";
import Context from "./Context";
import { onSnapshot } from "firebase/firestore";
/*
  This provider is used to listen to changes in a document.
  The state dictonary will hold a key value pair of the document id and a boolean that indicates if the document is being listened to.
*/

const UPDATE = "UPDATE";
function reducer(state, action) {
  const { type, prop, propVal } = action;

  switch (type) {
    case UPDATE:
      return { ...state, [prop]: propVal };
    default:
      throw new Error("No matching type for document listener.");
  }
}

const Provider = ({ children }) => {
  const [stateDictionary, dispatch] = useReducer(reducer, {});

  const listen = (name, docRef, onChangeFunc) => {
    dispatch({
      type: UPDATE,
      prop: name,
      propVal: true,
    });

    const unsubscribe = onSnapshot(docRef, async (doc) => {
      const processed = await onChangeFunc(doc);
      if (processed) {
        unsubscribe();
        dispatch({
          type: UPDATE,
          prop: name,
          propVal: false,
        });
      }
    });
  };

  return (
    <Context.Provider value={{ stateDictionary, listen }}>
      {children}
    </Context.Provider>
  );
};

export default Provider;
